export function mapFoldersToCourses(folders) {
  return (folders || []).map((item) => ({
    value: item,
    name: item,
  }));
}

export function handleError(commit, error, context = '') {
  const errorMessage =
    error?.message || error || 'An unexpected error occurred';
  console.error(context ? `[${context}]` : '[AI Module Error]', errorMessage);
  commit('setError', errorMessage);
  commit('setIsGeneratingResponse', false);
  commit('setIsFetchingOptions', false);
}

export function ensureProviderExists(state, provider) {
  if (!state.providers[provider]) {
    state.providers[provider] = {
      options: {},
      selected: {},
    };
  }
  if (!state.providers[provider].options) {
    state.providers[provider].options = {};
  }
  if (!state.providers[provider].selected) {
    state.providers[provider].selected = {};
  }
}

export function processResources(resources, provider) {
  if (!resources || !Array.isArray(resources) || resources.length === 0) {
    return [];
  }

  const processedResources = [];
  const seenDisplayNames = new Set();

  resources.forEach((resource, index) => {
    let normalizedResource = {};

    switch (provider) {
      case 'aws':
        normalizedResource = {
          id: resource.key || `aws-resource-${index}`,
          displayName: getAwsResourceDisplayName(resource, index, resources.length),
          key: resource.key,
          provider: 'aws',
          metadata: resource.metadata || {},
          course: resource.course || null,
          originalResource: resource,
        };
        break;

      case 'vertex': {
        const displayName = getVertexResourceDisplayName(resource, index);
        if (seenDisplayNames.has(displayName)) return;
        seenDisplayNames.add(displayName);

        normalizedResource = {
          id: resource.uri || resource.document || `vertex-resource-${index}`,
          displayName: displayName,
          uri: resource.uri,
          title: resource.title,
          content: resource.content,
          relevanceScore: resource.relevanceScore,
          document: resource.document,
          pageIdentifier: resource.pageIdentifier,
          provider: 'vertex',
          metadata: resource.structData || {},
          originalResource: resource,
        };
        break;
      }
      case 'pragya':
        normalizedResource = {
          id: resource.id || resource.key || `pragya-resource-${index}`,
          displayName: getPragyaResourceDisplayName(resource, index, resources.length),
          provider: 'pragya',
          originalResource: resource,
        };
        break;

      default:
        normalizedResource = {
          id: resource.id || resource.key || resource.uri || `${provider}-resource-${index}`,
          displayName: resource.displayName || resource.title || resource.name || `Resource ${index + 1}`,
          provider: provider,
          originalResource: resource,
        };
    }

    processedResources.push(normalizedResource);
  });

  return processedResources;
}

export function getAwsResourceDisplayName(resource, index, totalResources) {
  const filename = resource?.metadata?.filename;
  if (filename && filename.trim()) return filename;
  if (totalResources === 1) return 'Resource';
  return `Resource ${index + 1}`;
}

export function getVertexResourceDisplayName(resource, index) {
  if (resource.title && resource.title.trim()) return resource.title.trim();
  if (resource.uri) {
    const uriParts = resource.uri.split('/');
    const filename = uriParts[uriParts.length - 1];
    if (filename && filename.trim() && !filename.includes('?')) return filename.trim();
  }
  return `Resource ${index + 1}`;
}

export function getPragyaResourceDisplayName(resource, index, totalResources) {
  if (resource.title) return resource.title;
  if (totalResources === 1) return 'Resource';
  return `Resource ${index + 1}`;
}
